import styled from "@emotion/styled";
import { Card } from "react-bootstrap";
import { DEFAULT_CARD_STYLES } from "../../../shared/styles/Card.styles";
import { IStyledComponentProps } from "../../../theme/theme.types";

const PackageSelector = styled(Card)<IStyledComponentProps>`
  &.package-selector {
    ${DEFAULT_CARD_STYLES}

    @media (max-width: ${({ theme }) =>
      theme.utils.getThemeBreakpoint("tablet")}) {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

const PackageSelectorHeader = styled(Card.Header)<IStyledComponentProps>`
  &.package-selector-header {
    background-color: ${({ theme }) => theme.colors.essential.white};

    border-radius: 0;
    min-height: 96px;

    h4 {
      color: ${({ theme }) => theme.colors.grays.septenary};
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      margin: 12px 0;
    }

    @media (max-width: ${({ theme }) =>
        theme.utils.getThemeBreakpoint("tablet")}) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.grays.tertiary};
      margin-bottom: 16px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }
`;

const PackageSelectorBody = styled(Card.Body)<IStyledComponentProps>`
  &.package-selector-body {
    padding: 0;

    @media (max-width: ${({ theme }) =>
        theme.utils.getThemeBreakpoint("tablet")}) {
      margin-bottom: 20px;
      padding-left: 16px;
      padding-right: 16px;
      .package-list-label {
        display: block;
        font-family: ${({ theme }) => theme.fontFamilies.semiBold};
        margin-bottom: 8px;
      }
    }
  }
`;

export default {
  PackageSelector,
  PackageSelectorHeader,
  PackageSelectorBody,
};
